import React from "react";
import { formatCurrency } from "../../helpers/utils";
import { OrderStatusCell, PrepTimeCell } from "../../components/orderProgress";

export default function PreorderRow({ item, onClick }) {

  const isCompany = item?.ebarimtType === "COMPANY";
  const registerNumber = item?.ebarimtRegister;

  const preDate = item?.preOrderDate?.date || "-";
  const preFrom = item?.preOrderDate?.from || "";
  const preTo = item?.preOrderDate?.to || "";

  const preTimeText =
    preFrom && preTo ? `${preFrom} - ${preTo}` : preFrom || preTo || "-";

  return (
    <tr onClick={onClick} key={item.id} style={{ cursor: "pointer" }}>
      {/* ✅ Урьдчилсан огноо/цаг эхэнд */}
      <td className="text-center">
        <div style={{ fontWeight: 600 }}>{preDate}</div>
        <div className="text-muted" style={{ fontSize: 12, marginTop: 2 }}>
          {preTimeText}
        </div>
      </td>

      <td className="text-center">#{item?.orderCode}</td>

      <td className="text-center">
        <div>
          {item?.district?.name} {item.address}
        </div>

        <div
          style={{
            fontSize: 16,
            color: "#6c757d",
            marginTop: 2,
          }}
        >
          <span style={{ fontWeight: 600 }}>
            {isCompany ? "Байгууллага" : "Хувь хүн"}
          </span>

          {isCompany && registerNumber && (
            <span> | Регистер: {registerNumber}</span>
          )}
        </div>
      </td>

      <td className="text-center">{formatCurrency(item?.totalAmount)}</td>

      <td className="text-center">{item?.createdAt}</td>

      {/* Шуурхай захиалгын мөртэй ИЖИЛ нүднүүд (components/orderProgress). */}
      <PrepTimeCell item={item} />
      <OrderStatusCell item={item} />
    </tr>
  );
}
